/**
 * 数值范围输入框
 */
export default {
  name: 'number-range',
  dataType: 'Array',
  label: '数值范围',
  icon: 'el-icon-c-scale-to-original',
  config: [{
    xtype: 'text',
    options: {
      label: '输入提示',
      name: 'placeholder',
      default: '请输入数值范围'
    }
  }]
};